export default __webpack_public_path__ + "static/media/head.9182d045.png";